<template>
  <v-container class="py-10" id="zukunftstechnologien">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#0391af">Chancen</div>
        <h2>Zukunftstechnologien</h2>
        <p>
          KI, 3D Druck, und Cloud-Computing werden allgemein als die
          Technologien der Zukunft gesehen. Aber sehen das auch soziale
          Organisationen so? Die Ergebnisse unserer Studie zeigen, dass die
          Organisationen größtenteils sehr skeptisch sind, was diese
          Technologien angeht. Egal ob KI, Blockchain, Virtual Reality oder
          Chatbots &nbsp;&ndash; nur etwa <b>10%</b> der Organisationen sehen
          ein Potenzial für die eigene Organisation. Die Ausnahme ist
          Cloud-Computing. Hier sehen <b>40%</b> der Organisationen großes oder
          sehr großes Potenzial. Während sich alle Organisationen ihre Meinung
          zu den Themen KI und Chatbots gebildet zu haben scheinen, sind sie
          sich insbesondere bei Blockchain und IoT teilweise noch unsicher.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'Zukunftstechnologien' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "zukunftstechnologien",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text:
            "Wie hoch wird das Portenzial von Zukunftstechnologien für die eigene Organisation eingeschätzt?"
        },
        xAxis: {
          categories: [
            "Blockchain",
            "Künstliche Intelligenz",
            "Chatbots",
            "3D Druck",
            "Internet of Things",
            "Cloud-Computing",
            "Virtual Reality, Augmented Reality"
          ],
          crosshair: true
        },
        colors: ["#005a85", "#0391af", "#444"],
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        legend: {
          reversed: true
        },
        series: [
          {
            name: "Großes oder sehr großes Potenzial",
            data: [4.06, 12.07, 7.47, 11.19, 10.81, 40.47, 14.75]
          },
          {
            name: "Kein oder mäßiges Potenzial",
            data: [61.83, 77.7, 80.16, 82.27, 64.87, 49.52, 70.22]
          },
          {
            name: "Kann nicht eingeschätzt werden",
            data: [34.11, 10.23, 12.37, 6.53, 24.32, 10.01, 15.03]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Zukunftstechnologien",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
